export default {
  SET_PROMOS (state, promos) {
    state.promos = promos
  },
  REMOVE_RECORD (state, itemId) {
    const roleIndex = state.promos.findIndex((u) => u.id === itemId)
    state.promos.splice(roleIndex, 1)
  }
}
